import {Errors} from 'Shared/components/ErrorPopover';
import {ToMatchOptions} from 'Shared/utilities/MapDiscriminatedUnion';

export class InvalidAgentNumber {
  public readonly key = 'InvalidAgentNumber';

  constructor(public readonly value: string) {}
}

export class ValidAgentNumber {
  public static create(value: string) {
    return value.length === 5 ? new ValidAgentNumber(value) : new InvalidAgentNumber(value);
  }

  public readonly key = 'ValidAgentNumber';
  private constructor(public readonly value: string) {}
}

export type AgentNumber = ValidAgentNumber | InvalidAgentNumber;

export type AgentNumberOptions<TReturn> = ToMatchOptions<AgentNumber, 'key', TReturn>;

export const matchAgentNumber = <TReturn>(phoneNumber: AgentNumber, options: AgentNumberOptions<TReturn>): TReturn => {
  switch (phoneNumber.key) {
    case 'InvalidAgentNumber':
      return options.InvalidAgentNumber(phoneNumber);
    case 'ValidAgentNumber':
      return options.ValidAgentNumber(phoneNumber);
  }
};

export const getAgentNumberErrors = (agentNumber: AgentNumber) =>
  Errors.standardErrors({
    value: isValidAgentNumber(agentNumber)
      ? []
      : agentNumber.value.length === 0
      ? ['Please provide a value.']
      : ['Must be exactly 5 characters.'],
  });

export const isValidAgentNumber = (agentNumber: AgentNumber): agentNumber is ValidAgentNumber =>
  agentNumber.key === 'ValidAgentNumber';
